'use client';

import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';

// Dynamic import with SSR disabled
const MyAliceChat = dynamic(() => import('@/features/MyAliceChat'), {
  ssr: false,
  loading: () => <></>, // or a placeholder
});

export default function LazyMyAliceChat() {
  const [showChat, setShowChat] = useState(false);

  useEffect(() => {
    // Delay for better performance
    const timer = setTimeout(() => {
      setShowChat(true);
    }, 3000); // delay 3s or after first user interaction
    return () => clearTimeout(timer);
  }, []);

  return showChat ? <MyAliceChat /> : null;
}
